import 'css/fonts.css';

import { AppProps } from 'next/app';
import Head from 'next/head';

import { CalmTheme, DesignSystemProvider } from '@calm-web/design-system';

import AppLayout from '@/components/app/layout/AppLayout';
import { AppHeaderProps } from '@/components/app/layout/AppLayout/types';
import AppProviders from '@/components/app/layout/AppProviders';
import PageWrapper from '@/components/layout/PageWrapper';
import StoreProvider from '@/components/layout/StoreProvider';
import { AppInitialState } from '@/store';
import { getBundledMessages } from '@/utils/locale/pagesRouterMessages';

const MyApp = ({
	Component,
	pageProps,
}: AppProps<{
	initialState: AppInitialState;
	appHeaderProps: AppHeaderProps;
	hideAcceptCookiesModal?: boolean;
	customMainId?: string;
}>) => {
	const locale = pageProps.initialState?.locale || 'en';
	const messages = getBundledMessages(locale);

	return (
		<>
			<Head>
				<link rel="shortcut icon" type="image/x-icon" href="/_n/favicon.ico" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
			</Head>
			<StoreProvider initialState={pageProps.initialState}>
				<DesignSystemProvider theme={CalmTheme}>
					<PageWrapper
						customMainId={pageProps.customMainId}
						locale={locale}
						messages={messages}
						hideAcceptCookiesModal={pageProps.hideAcceptCookiesModal}
					>
						<AppProviders>
							<AppLayout appHeaderProps={pageProps.appHeaderProps}>
								<Component {...pageProps} />
							</AppLayout>
						</AppProviders>
					</PageWrapper>
				</DesignSystemProvider>
			</StoreProvider>
		</>
	);
};

export default MyApp;
